import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { LayoutGrid, FileStack, LogOut, Loader2 } from "lucide-react";
import { Logo } from "@/components/brand/Logo";

const ExecutiveLayout = () => {
  const { user, signOut, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const items = [
    { to: "/executive", label: "Reports Shared With Me", icon: LayoutGrid, exact: true },
    { to: "/executive/rollups", label: "My Roll-Up Reports", icon: FileStack },
  ];

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-card">
        <div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between">
          <Link to="/executive" className="flex items-center gap-2">
            <Logo size="sm" to={null} />
            <span className="text-sm text-muted-foreground hidden sm:inline">Executive</span>
          </Link>
          <div className="flex items-center gap-3">
            <span className="text-sm text-muted-foreground hidden md:inline">{user?.email}</span>
            <Button
              variant="outline"
              size="sm"
              onClick={async () => { await signOut(); navigate("/signin"); }}
              disabled={loading}
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <><LogOut className="w-4 h-4 mr-2" />Sign Out</>}
            </Button>
          </div>
        </div>
        <nav className="max-w-6xl mx-auto px-6 flex gap-1">
          {items.map((it) => {
            const active = it.exact
              ? location.pathname === it.to
              : location.pathname.startsWith(it.to);
            return (
              <Link
                key={it.to}
                to={it.to}
                className={`flex items-center gap-2 px-4 py-3 text-sm border-b-2 transition-colors ${
                  active
                    ? "border-primary text-foreground font-medium"
                    : "border-transparent text-muted-foreground hover:text-foreground"
                }`}
              >
                <it.icon className="w-4 h-4" />
                {it.label}
              </Link>
            );
          })}
        </nav>
      </header>
      <main className="max-w-6xl mx-auto px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default ExecutiveLayout;
